import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff, deduplicateRequest } from '../common';

import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.salones;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'salones',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});


// Function to fetch all salones
export const getAllSalones = async () => {
  return await cachedApi.get('/GetAllSalones');
};

// Function to fetch salones by company ID
export const getSalonesByCompanyId = async (companyId: number) => {
  return await cachedApi.get(`/GetSalonesByCompanyId/${companyId}`);
};

// /GetSalonesListByLocalId/<int:local_id>

export const getSalonesListByLocalId = async (localId: number) => {
  return await cachedApi.get(`/GetSalonesListByLocalId/${localId}`);
}

// Function to fetch salones by local ID
/**
 * Get salones by local ID - with retry policy and request deduplication.
 * Uses standard cache infrastructure with 2 minute TTL.
 * Also deduplicates concurrent requests to prevent multiple simultaneous calls.
 */
export const getSalonesByLocalId = async (localId: number) => {
  return await deduplicateRequest(
    `getSalonesByLocalId:${localId}`,
    () => retryWithBackoff(() =>
      cachedApi.get(`/GetSalonesByLocalId/${localId}`, undefined, { ttl: '2m' })
    )
  );
};

// Function to fetch a single salon by ID
export const getSalonById = async (salonId: number) => {
  return await cachedApi.get(`/GetSalonById/${salonId}`);
};

// Function to create a salon
export const createSalon = async (salonData: any) => {
  const res = await api.post('/CreateSalon', salonData, {});
  await cachedApi.clear();
  return res;
};

// Function to update a salon
export const updateSalon = async (salonId: number, salonData: any) => {
  const res = await api.put(`/UpdateSalon/${salonId}`, salonData, {});
  await cachedApi.clear();
  return res;
};

// Function to delete a salon and its related mesas and objetos
export const deleteSalon = async (salonId: number) => {
  const res = await api.delete(`/DeleteSalon/${salonId}`, {});
  await cachedApi.clear();
  return res;
};


export const initDefaultSalonesByLocalId = async ( salonData: any) => {
  const res = await api.post(`/InitDefaultSalonesByLocalId`, salonData, {});
  await cachedApi.clear();
  return res;
};

export const deleteSalonesRegistration = async (code: string) => {
  const res = await api.delete(`/DeleteSalonesRegistration/${code}`, {});
  await cachedApi.clear();
  return res;
};